import { RxJsonSchema, RxDocument } from 'rxdb';
import { PathTest, TaskType } from '../models';
import { TaskAssignmentsSchemaObjectDef, TaskScheduleSchemaObjectDef, TaskStatusGroupSchemaObjectDef } from './task-schema';

export const pathTestMethods = {
}

export type PathTestDoc = RxDocument<PathTest,typeof pathTestMethods>

export const pathTestSchema: RxJsonSchema<PathTest> = {
    title: 'path test schema',
    version: 3,
    keyCompression: false,
    type: 'object',
    properties: {
        _id: {
            type: 'string',
            primary: true,
            default: ''
        },
        pathId: {
            type: 'string'
        },
        assignedUserId: {
            type: 'string'
        },        
        title: {
            type: 'string'
        },
        type: {
            type: 'string',
            default: TaskType.PATH_TEST
        },
        stage: {
            type: 'string'
        },
        buildingId: {
            type: 'string'
        },
        cycle: {
            type: 'number'
        },
        groupingfield: {
            type: ['string','null']
        },
        order: {
            type: ['number','null']
        },
        schedule: TaskScheduleSchemaObjectDef,
        assignments: TaskAssignmentsSchemaObjectDef,
        status: TaskStatusGroupSchemaObjectDef,  
        testPoints: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    id: {
                        type: 'string'
                    },
                    pointId: {
                        type: 'string',
                        ref: 'point'
                    },
                    order: {
                        type: 'number'
                    },
                    statusId: {
                        type: 'number'
                    },
                    seqs: {
                        type: 'array',
                        items: {
                            properties: {
                                id: {
                                    type: 'string'
                                },
                                startTime: {
                                    type: ['string', 'null']
                                },
                                stopTime: {
                                    type: ['string', 'null']
                                },
                                dialerSeqId: {
                                    type: ['string', 'null']
                                },
                                userId: {
                                    type: ['string', 'null']
                                },
                                data: {
                                    type: [ 'object', 'null' ],
                                    "properties": {
                                        callsPlaced: { 
                                            type: ['number', 'null'] 
                                        },
                                        callsCompleted: { 
                                            type: ['number', 'null'] 
                                        },
                                        type: { 
                                            type: ['string', 'null']
                                        },
                                        timestamp: { 
                                            type: ['string', 'null']
                                        },
                                        userId: { 
                                            type: ['string', 'null']
                                        },
                                        hvac: { 
                                            type: ['string', 'null']
                                        },
                                        doorOpenShutCount: { 
                                            type: ['number', 'null']
                                        },
                                        footTraffic: { 
                                            type: ['string', 'null']
                                        },
                                        att: { 
                                            type: ['number', 'null']
                                        },
                                        verizon: { 
                                            type: ['number', 'null']
                                        },
                                        tmobile: { 
                                            type: ['number', 'null']
                                        },
                                        dish: { 
                                            type: ['number', 'null']
                                        },
                                        issues: { 
                                            type: ['string', 'null']
                                        }
                                    }
                                }
                            }  
                        }
                    }
                }
            }
        },
        overlay: {
            type: [ 'object', 'null' ]
        },
        gpx: {
            type: [ 'object', 'null' ]
        },
    },
    required: ['_id'],
    indexes: ['_id', 'assignedUserId', 'type', 'buildingId', 'testPoints.[].id']
};
